@if (!manageOnlySecondaryEmails) {
  <div class="email-row">
    <div>
      <span class="email-address">{{ primaryEmail }}</span>
      <span class="primary-description"
        >The Primary Email Receives All Notifications</span
      >
    </div>
    <div class="email-actions">
      <span class="primary-tag">Primary</span>
    </div>
  </div>
}

@for (item of emailsItems; track $index) {
  <div class="email-row">
    <div>
      <span class="email-address">{{ item.email }}</span>
    </div>
    <div class="email-actions">
      @if (!readOnly) {
        @if (item.isVerified) {
          <button
            mat-button
            color="primary"
            [disabled]="pendingMakePrimaryId === item.id || !!pendingDeleteId"
            (click)="confirmMakePrimary(item)"
          >
            @if (pendingMakePrimaryId === item.id) {
              <mat-spinner
                diameter="16"
                strokeWidth="2"
                class="btn-spinner"
              ></mat-spinner>
            }
            Make Primary
          </button>
        } @else {
          <button
            mat-button
            class="verify-button"
            [disabled]="!!pendingDeleteId || !!pendingMakePrimaryId"
            (click)="verify.emit(item)"
          >
            Verify Email
          </button>
        }
        @if (pendingDeleteId === item.id) {
          <mat-spinner diameter="18" strokeWidth="2"></mat-spinner>
        } @else {
          <button
            mat-icon-button
            class="outlined-button"
            [attr.aria-label]="'Delete ' + item.email"
            [disabled]="pendingDeleteId === item.id || !!pendingMakePrimaryId"
            (click)="confirmDelete(item)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        }
      }
    </div>
  </div>
}
@if (isAddingEmail) {
  <div class="add-email-form">
    <mat-form-field appearance="outline" class="add-email-field">
      <mat-label>{{
        manageOnlySecondaryEmails ? 'Secondary Email' : 'New Email'
      }}</mat-label>
      <input
        matInput
        type="email"
        [formControl]="addEmailControl"
        (keyup.enter)="submitAdd()"
        autocomplete="email"
      />
      @if (addEmailControl.hasError('required') && addEmailControl.touched) {
        <mat-error>Email is required</mat-error>
      } @else if (
        addEmailControl.hasError('email') && addEmailControl.touched
      ) {
        <mat-error>Please enter a valid email address</mat-error>
      } @else if (addEmailControl.hasError('duplicate')) {
        <mat-error>This email address already exists on the profile</mat-error>
      }
    </mat-form-field>
    <div class="add-email-actions">
      <button
        mat-flat-button
        color="primary"
        [disabled]="isSaving"
        (click)="submitAdd()"
      >
        {{ isSaving ? 'Adding...' : 'Add' }}
      </button>
      <button mat-button [disabled]="isSaving" (click)="cancelAdd()">
        Cancel
      </button>
    </div>
  </div>
} @else if (!readOnly) {
  @if (manageOnlySecondaryEmails) {
    <button mat-stroked-button color="primary" (click)="showAddForm()">
      <mat-icon>add</mat-icon>Add Secondary Email
    </button>
  } @else {
    <button mat-stroked-button color="primary" (click)="showAddForm()">
      <mat-icon>add</mat-icon
      >{{ emailsItems.length == 0 ? 'Add New Email' : 'Add Another Email' }}
    </button>
  }
}
